import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { useArticlesContext } from "../context/ArticlesContext";
import HomeArticlesGrid from "../components/HomeArticlesGrid"; // <-- ADDED IMPORT

const Home = () => {
  const { articles } = useArticlesContext();

  // State to hold the randomly selected articles
  const [randomArticles, setRandomArticles] = useState([]);

  // On mount (and whenever articles update), pick 3 random articles from context
  useEffect(() => {
    if (articles.length > 0) {
      const shuffled = [...articles].sort(() => 0.5 - Math.random());
      setRandomArticles(shuffled.slice(0, 3));
    }
  }, [articles]);

  return (
    <>
      <Navbar />

      {/* Hero Section */}
      <section className="hero">
        <div className="hero-content container">
          <h1>
            Welcome to <span>Vancouver</span>
          </h1>
          <p>
            Your go-to for restaurants, adventures, trails, and all the good-to-know
            things about Vancouver.
          </p>
          <Link to="/articles" className="btn">
            Start Exploring
          </Link>
        </div>
      </section>

      {/* Main Content */}
      <main>
        {/* Latest Articles Section (Existing Random Articles) */}
        <HomeArticlesGrid count={4} />
      </main>

      <Footer />
    </>
  );
};

export default Home;